import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=f5c70130&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"
import style0 from "./userList.vue?vue&type=style&index=0&id=f5c70130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c70130",
  null
  
)

export default component.exports